<form #form="ngForm">
  <div class="form-grid">
    <sh-field
      label="uiModules.pageSize"
      [required]="true"
      [error]="
        psize.invalid && (psize.dirty || psize.touched || submitted)
          ? 'uiModules.error.pageSizeRequired'
          : null
      "
    >
      <sh-number
        name="psize"
        #psize="ngModel"
        [(ngModel)]="configuration.pageSize"
        required
      ></sh-number>
    </sh-field>
    <sh-field label="uiModules.sorting">
      <sh-select
        [options]="sortOrderOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="shared.terms.select"
        [(value)]="configuration.sortOrder"
      ></sh-select>
    </sh-field>
    <sh-field
      class="field-wide"
      label="uiModules.sortFieldCode"
      [required]="true"
      [error]="
        sortFieldCode.invalid &&
        (sortFieldCode.dirty || sortFieldCode.touched || submitted)
          ? 'uiModules.error.sortFieldRequired'
          : null
      "
    >
      <sh-input
        name="sortFieldCode"
        #sortFieldCode="ngModel"
        [(ngModel)]="configuration.sortFieldCode"
        required
      ></sh-input>
    </sh-field>
    <sh-field
      class="field-wide"
      label="uiModules.displayColumns"
      [required]="true"
    >
      <sh-multiselect
        [options]="displayFieldsOptions"
        optionLabel="label"
        optionValue="value"
        display="chip"
        [filter]="true"
        [formControl]="displayFieldsControl"
      ></sh-multiselect>
    </sh-field>
    <sh-field
      *ngIf="configurableFieldOptions.length"
      class="field-wide"
      label="uiModules.addFieldConfiguration"
    >
      <sh-select
        #fieldConfigPicker
        [options]="configurableFieldOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="shared.terms.select"
        [filter]="true"
        (valueChange)="
          addFieldConfiguration($event); fieldConfigPicker.value.set(null)
        "
      ></sh-select>
    </sh-field>
  </div>

  <su-field-configuration-template
    class="d-block mt-3"
    [configuration]="configuration.displayFieldsConfiguration"
    (configurationChange)="setFieldConfigurations($event)"
  ></su-field-configuration-template>

  <sh-tabs
    #sectionTabs
    class="d-block mt-4"
    [tabs]="sections"
    [(active)]="activeSection"
  ></sh-tabs>
  <sh-tab-panels [for]="sectionTabs">
    <!-- Header -->
    <ng-template shTabPanel="header">
      <div class="setting-list mt-3">
        <div class="setting-group">
          <div class="setting-row">
            <sh-toggle
              ariaLabel="uiModules.hasHeaderConfiguration"
              [disabled]="!!seahorseModule"
              [value]="hasHeaderConfiguration"
              (valueChange)="
                hasHeaderConfiguration = $event; toggleHeaderConfiguration()
              "
            ></sh-toggle>
            <div class="setting-text">
              <div class="setting-name">
                {{ 'uiModules.hasHeaderConfiguration' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="hasHeaderConfiguration">
        <div class="setting-list mt-3">
          <div class="setting-group">
            <div class="setting-row">
              <sh-toggle
                ariaLabel="uiModules.allowSimpleSearch"
                [(value)]="configuration.headerConfig.showSimpleSearch"
              ></sh-toggle>
              <div class="setting-text">
                <div class="setting-name">
                  {{ 'uiModules.allowSimpleSearch' | translate }}
                </div>
              </div>
            </div>
            <div class="setting-row">
              <sh-toggle
                ariaLabel="uiModules.allowAdvancedSearch"
                [(value)]="configuration.headerConfig.showAdvancedSearch"
              ></sh-toggle>
              <div class="setting-text">
                <div class="setting-name">
                  {{ 'uiModules.allowAdvancedSearch' | translate }}
                </div>
              </div>
            </div>
            <div class="setting-row">
              <sh-toggle
                ariaLabel="uiModules.allowExport"
                [(value)]="configuration.headerConfig.showExportButton"
              ></sh-toggle>
              <div class="setting-text">
                <div class="setting-name">
                  {{ 'uiModules.allowExport' | translate }}
                </div>
              </div>
            </div>
            <div class="setting-row">
              <sh-toggle
                ariaLabel="uiModules.allowAdding"
                [(value)]="configuration.headerConfig.showAddButton"
              ></sh-toggle>
              <div class="setting-text">
                <div class="setting-name">
                  {{ 'uiModules.allowAdding' | translate }}
                </div>
              </div>
            </div>
            <div class="setting-row">
              <sh-toggle
                ariaLabel="uiModules.allowBatchUpdates"
                [(value)]="configuration.headerConfig.showBatchUpdateButton"
              ></sh-toggle>
              <div class="setting-text">
                <div class="setting-name">
                  {{ 'uiModules.allowBatchUpdates' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-grid mt-3">
          <sh-field
            class="field-wide"
            label="invoicing.invoiceModel.invoiceFlow"
          >
            <sh-multiselect
              [options]="invoiceFlowOptions"
              optionLabel="label"
              optionValue="value"
              display="chip"
              [formControl]="invoiceFlowsControl"
            ></sh-multiselect>
          </sh-field>
          <sh-field label="invoicingFlows.selectedFlow">
            <sh-select
              [options]="selectedInvoiceFlowOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="invoicingFlows.selectedFlow"
              [(value)]="configuration.headerConfig.selectedFlow"
            ></sh-select>
          </sh-field>
          <sh-field label="invoicingFlows.debtorSelector">
            <sh-select
              [options]="companyFields"
              optionLabel="label"
              optionValue="value"
              placeholder="invoicingFlows.debtorSelector"
              [showClear]="true"
              [(value)]="configuration.headerConfig.debtorSelector"
            ></sh-select>
          </sh-field>
        </div>
      </ng-container>
    </ng-template>

    <!-- Grouping -->
    <ng-template shTabPanel="groups">
      <div class="setting-list mt-3">
        <div class="setting-group">
          <div class="setting-row">
            <sh-toggle
              ariaLabel="uiModules.groupInformationInBoxes"
              [disabled]="!!seahorseModule"
              [value]="hasGroupsConfiguration"
              (valueChange)="
                hasGroupsConfiguration = $event; toggleGroupsConfiguration()
              "
            ></sh-toggle>
            <div class="setting-text">
              <div class="setting-name">
                {{ 'uiModules.groupInformationInBoxes' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="hasGroupsConfiguration" class="form-grid mt-3">
        <sh-field label="uiModules.groupBy">
          <sh-select
            [options]="simpleFieldDefinitions"
            optionLabel="name"
            optionValue="systemCode"
            placeholder="shared.terms.select"
            [filter]="true"
            [value]="configuration.groupsConfig.field"
            (valueChange)="setGroupByField($event)"
          ></sh-select>
        </sh-field>
        <sh-field label="uiModules.sortGroupsBy">
          <sh-input [(value)]="configuration.groupsConfig.sort"></sh-input>
        </sh-field>
      </div>
    </ng-template>

    <!-- Summary -->
    <ng-template shTabPanel="summary">
      <div class="setting-list mt-3">
        <div class="setting-group">
          <div class="setting-row">
            <sh-toggle
              ariaLabel="uiModules.hasSummaryConfiguration"
              [disabled]="!!seahorseModule"
              [value]="hasSummaryConfiguration"
              (valueChange)="
                hasSummaryConfiguration = $event; toggleSummaryConfiguration()
              "
            ></sh-toggle>
            <div class="setting-text">
              <div class="setting-name">
                {{ 'uiModules.hasSummaryConfiguration' | translate }}
              </div>
            </div>
          </div>
          <div class="setting-row" *ngIf="hasSummaryConfiguration">
            <sh-toggle
              ariaLabel="uiModules.canEditFieldsInSummary"
              [(value)]="configuration.summaryConfig.allowEdit"
            ></sh-toggle>
            <div class="setting-text">
              <div class="setting-name">
                {{ 'uiModules.canEditFieldsInSummary' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="hasSummaryConfiguration">
        <div class="form-grid mt-3">
          <sh-field class="field-wide" label="uiModules.displayedFields">
            <sh-multiselect
              [options]="displayFieldsOptions"
              optionLabel="label"
              optionValue="value"
              display="chip"
              [filter]="true"
              [(value)]="configuration.summaryConfig.fields"
            ></sh-multiselect>
          </sh-field>
        </div>

        <div class="mt-3">
          <div class="meta mb-2">{{ 'uiModules.actions' | translate }}</div>
          <sh-table
            *ngIf="configuration.summaryConfig.actions?.length"
            tableId="ui-module-summary-actions"
            density="compact"
            dataKey="fieldCode"
            [columns]="actionColumns"
            [rows]="configuration.summaryConfig.actions"
            [rowActions]="actionRowActions"
          ></sh-table>
          <div class="form-grid mt-3">
            <sh-field label="uiModules.actionDisplayName">
              <sh-input [(value)]="newAction.displayName"></sh-input>
            </sh-field>
            <sh-field label="uiModules.actionIcon">
              <sh-input [(value)]="newAction.icon"></sh-input>
            </sh-field>
            <sh-field class="field-wide" label="uiModules.fieldCode">
              <div class="input-with-action">
                <sh-input [(value)]="newAction.fieldCode"></sh-input>
                <sh-button
                  label="shared.terms.add"
                  severity="secondary"
                  icon="fa-regular fa-plus"
                  (click)="addAction()"
                ></sh-button>
              </div>
            </sh-field>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <!-- Required data -->
    <ng-template shTabPanel="requiredData">
      <div class="setting-list mt-3 mb-3">
        <div class="setting-group">
          <div class="setting-row">
            <sh-toggle
              ariaLabel="uiModules.hasRequiredData"
              [value]="hasRequiredDataConfiguration"
              (valueChange)="
                hasRequiredDataConfiguration = $event;
                toggleRequiredDataConfiguration()
              "
            ></sh-toggle>
            <div class="setting-text">
              <div class="setting-name">
                {{ 'uiModules.hasRequiredData' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <su-required-data-editor
        *ngIf="hasRequiredDataConfiguration"
        [(items)]="configuration.requiredData"
      ></su-required-data-editor>
    </ng-template>

    <!-- Task progress -->
    <ng-template shTabPanel="taskProgress">
      <div class="setting-list mt-3">
        <div class="setting-group">
          <div class="setting-row">
            <sh-toggle
              ariaLabel="uiModules.showTasksProgress"
              [value]="hasTasksProgressConfiguration"
              (valueChange)="
                hasTasksProgressConfiguration = $event;
                toggleTasksProgressConfiguration()
              "
            ></sh-toggle>
            <div class="setting-text">
              <div class="setting-name">
                {{ 'uiModules.showTasksProgress' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="hasTasksProgressConfiguration" class="form-grid mt-3">
        <sh-field label="uiModule.taskProgress.displayType.label">
          <sh-select
            [options]="taskProgressDisplayTypeOptions"
            optionLabel="label"
            optionValue="value"
            [(value)]="configuration.taskProgressConfig.displayType"
          ></sh-select>
        </sh-field>
        <sh-field label="uiModule.taskProgress.displayFormat.label">
          <sh-select
            [options]="taskProgressDisplayFormatOptions"
            optionLabel="label"
            optionValue="value"
            [(value)]="configuration.taskProgressConfig.displayFormat"
          ></sh-select>
        </sh-field>
        <sh-field label="uiModule.taskProgress.indicatorType.label">
          <sh-select
            [options]="taskProgressIndicatorTypeOptions"
            optionLabel="label"
            optionValue="value"
            [(value)]="configuration.taskProgressConfig.indicatorType"
          ></sh-select>
        </sh-field>
        <sh-field
          class="field-wide"
          label="uiModule.taskProgress.colorMap.label"
        >
          <su-task-progress-color-map-editor
            [(colorMap)]="configuration.taskProgressConfig.colorMapping"
          ></su-task-progress-color-map-editor>
        </sh-field>
      </div>
    </ng-template>

    <!-- Default filter -->
    <ng-template shTabPanel="defaultFilter">
      <div class="setting-list mt-3">
        <div class="setting-group">
          <div class="setting-row">
            <sh-toggle
              ariaLabel="uiModules.defaultFilter"
              [disabled]="!!seahorseModule"
              [value]="hasDefaultFilter"
              (valueChange)="hasDefaultFilter = $event; toggleDefaultFilter()"
            ></sh-toggle>
            <div class="setting-text">
              <div class="setting-name">
                {{ 'uiModules.defaultFilter' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="hasDefaultFilter">
        <div class="form-grid mt-3">
          <sh-field class="field-wide" label="uiModules.includeInSearch">
            <sh-multiselect
              [options]="searchOptions"
              optionLabel="label"
              optionValue="value"
              [formControl]="includeInSearchControl"
            ></sh-multiselect>
          </sh-field>
          <sh-field class="field-wide" label="reports.customdata.fieldName">
            <sh-select
              *ngIf="defaultFilterRemainingFields.length > 0"
              #filterFieldPicker
              [options]="defaultFilterRemainingFields"
              optionLabel="name"
              optionValue="systemCode"
              placeholder="shared.terms.select"
              [filter]="true"
              (valueChange)="
                selectDefaultFilter($event); filterFieldPicker.value.set(null)
              "
            ></sh-select>
            <div class="meta" *ngIf="defaultFilterRemainingFields.length === 0">
              {{ 'uiModules.filterIsSet' | translate }}
            </div>
          </sh-field>
        </div>

        <div class="mt-3" *ngIf="simpleFieldDefinitions.length > 0">
          <sh-table
            *ngIf="defaultFilterFields.length > 0; else noFilter"
            tableId="ui-module-default-filter"
            density="compact"
            dataKey="fieldName"
            [columns]="filterColumns"
            [rows]="defaultFilterFields"
            [rowActions]="filterRowActions"
          >
            <ng-template shCell="criteria" let-row>
              <su-field-operator-input
                [fieldType]="findFieldType(row)"
                [(operator)]="row.searchOperator"
                [(fieldValue)]="row.searchValue"
              ></su-field-operator-input>
            </ng-template>
          </sh-table>
          <ng-template #noFilter>
            <div class="meta">
              {{ 'uiModules.noFilterSelected' | translate }}
            </div>
          </ng-template>
        </div>
      </ng-container>
    </ng-template>
  </sh-tab-panels>
</form>
